import React from "react";
import logo from "../../../src/image/THOUGHTCODES-logo-white.png";

const Footer: React.FC = () => {
  return (
    <footer>
      <div className="container">
        <div className="footer-grid pb-10">
          <div className="text-white">
            <div>
              <img src={logo} alt="Logo" className="h-10 w-auto sm:h-auto" />
            </div>
            <div className="text-[#dbe6ff] text-md font-normal mt-5">
              Secure, scalable, and mission-focused digital solutions for
              government and mission-driven organizations.
            </div>
          </div>
          <div>
            <h3 className="text-white text-xl font-semibold mb-3">
              Core Services
            </h3>
            <div className="text-white text-md font-normal space-y-2">
              <a href="/services" className="hover:text-gray-300">
                Software Development
              </a>
              <br />
              <a href="/services" className="hover:text-gray-300">
                Cloud & DevSecOps
              </a>
              <br />
              <a href="/services" className="hover:text-gray-300">
                Cybersecurity
              </a>
              <br />
              <a href="/services" className="hover:text-gray-300">
                Systems Modernization
              </a>
            </div>
          </div>
          <div>
            <h3 className="text-white text-xl font-semibold mb-3">Contact</h3>
            <ul className="space-y-3 text-[#dbe6ff]">
              <li className="flex items-start gap-3">
                <svg
                  className="mt-0.5 h-5 w-5 text-[#8ec5ff]"
                  fill="none"
                  viewBox="0 0 24 24"
                  stroke="currentColor"
                  strokeWidth={1.8}
                >
                  <path
                    strokeLinecap="round"
                    strokeLinejoin="round"
                    d="M21.75 7.5v9a2.25 2.25 0 01-2.25 2.25h-15A2.25 2.25 0 012.25 16.5v-9m19.5 0A2.25 2.25 0 0019.5 5.25h-15A2.25 2.25 0 002.25 7.5m19.5 0v.243a2.25 2.25 0 01-.97 1.855l-7.5 5.25a2.25 2.25 0 01-2.56 0l-7.5-5.25a2.25 2.25 0 01-.97-1.855V7.5"
                  />
                </svg>
                <a
                  className="hover:text-white"
                  href="mailto:info@thoughtcodes.com"
                >
                  info@thoughtcodes.com
                </a>
              </li>
              <li className="flex items-start gap-3">
                <svg
                  className="mt-0.5 h-5 w-5 text-[#8ec5ff]"
                  fill="none"
                  viewBox="0 0 24 24"
                  stroke="currentColor"
                  strokeWidth={1.8}
                >
                  <path
                    strokeLinecap="round"
                    strokeLinejoin="round"
                    d="M2.25 4.5a1.5 1.5 0 011.5-1.5h2.25a1.5 1.5 0 011.5 1.29l.39 2.73a1.5 1.5 0 01-.43 1.3l-1.12 1.12a12 12 0 005.66 5.66l1.12-1.12a1.5 1.5 0 011.3-.43l2.73.39a1.5 1.5 0 011.29 1.5v2.25a1.5 1.5 0 01-1.5 1.5h-.75C9.31 21.75 2.25 14.69 2.25 6V4.5z"
                  />
                </svg>
                <a className="hover:text-white" href="tel:+7032312569">
                  + (703) 231-2569
                </a>
              </li>
              <li className="flex items-start gap-3">
                <svg
                  className="mt-0.5 h-6 w-6 text-[#8ec5ff]"
                  fill="none"
                  viewBox="0 0 24 24"
                  stroke="currentColor"
                  strokeWidth={1.8}
                >
                  <path
                    strokeLinecap="round"
                    strokeLinejoin="round"
                    d="M12 21s-6.75-5.625-6.75-11.25A6.75 6.75 0 1118.75 9.75C18.75 15.375 12 21 12 21z"
                  />
                  <circle cx="12" cy="9.75" r="2.25" />
                </svg>
                <span>4705 Eisenhower Ave Ste A, Alexandria, VA 22304</span>
              </li>
            </ul>
          </div>
        </div>
        <div className="text-sm text-center text-[#dbe6ff] pt-3 border-t border-white/10">
          Copyright © 2026 ThoughtCodes™. All rights reserved.
        </div>
      </div>
    </footer>
  );
};

export default Footer;

